import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';

import * as LoginActions from './actions';

import LoginNavBar from '../navigation/LoginNavBar';

import Button from '../components/Button';

import '../css/login.css';

const LoginPage = ({
  dispatch,
  isInitialLogin,
  loginResult,
  loginTried,
  handleChange,
  handleSubmit
}) => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const [ finetune, setFinetune ] = useState({
    finetuneX: window.innerWidth,
    finetuneY: window.innerHeight,
  });

  const handleResize = () => {
    setFinetune({
      finetuneX: window.innerWidth,
      finetuneY: window.innerHeight
    });
  }

  useEffect(() => {
    dispatch(initLogin());
  }, [pathname]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [window.innerWidth, window.innerHeight]);

  return (
    <div className='sans-serif bg-navy'>
      <div className='z-4 bg-custom-navy-20' style={{ width: '100%', height: '10%' }}>
        <LoginNavBar />
      </div>
      <div className='flex items-center justify-center' style={{ width: finetune.finetuneX, height: finetune.finetuneY * 0.9 }}>
        <div className='mt5 flex flex-column flex-wrap items-center' style={{ overflowY: 'auto' }}>
          <div className='bg-custom-navy-20 pa3'>
            <div className='flex justify-center items-center montserrat pa3 fw4 f3 white'>Log in to Your Account</div>
            { !loginResult && loginTried && <div className='tc mt3 mb3 pt3 pb3 border-red bg-red-100' >
                <span className='text-red-500'>Invalid login.</span>
              </div>}
            <div className='flex flex-column'>
              <form className='flex flex-column' onSubmit={handleSubmit}>
                <div className='san-serif white mb2'>EMAIL</div>
                <input
                  type="text"
                  name="emailAddress"
                  placeholder="Specify your e-mail address"
                  onChange={handleChange}
                  className='b--gray mb4'
                  style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                />
                <div className='san-serif white mb2'>PASSWORD</div>
                <input
                  type="password"
                  name="password"
                  placeholder="Specify your password"
                  autoComplete="on"
                  onChange={handleChange}
                  className='b--gray mb4'
                  style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                />
                <Button type="submit" className='montserrat mb4' style={{ padding: '8px' }} >SUBMIT</Button>
             </form>
            </div>
          </div>
          <p className='san-serif white'>Not yet a member? <button className='san-serif white underline' onClick={() => navigate("/signup")}>Sign up</button></p>
        </div>
      </div>
    </div>
  )
}

const initLogin = () => {
  return {
    type: LoginActions.LOGIN_INITPAGE,
  };
}

const mapStateToProps = state => ({
  isInitialLogin: state.login.isInitialLogin,
  loginResult: state.login.loginResult,
  loginTried: state.login.loginTried
});

export default connect(mapStateToProps)(LoginPage);
